import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { useSearchParams } from 'react-router';

import { useAppSelector } from 'src/app/store/hooks';
import { DataGrid } from 'src/common/DataGrid';
import { usePaginationState } from 'src/common/DataGrid/usePaginationState';
import {
  MembersListApiArg,
  useMembersListQuery,
} from 'src/common/external/bambi-api/bambiApi';

import { MemberForm } from '../MemberForm/MemberForm';
import { columns, columnsWithDeletedAt } from './columns';
import { MemberEmptyState } from './MemberEmptyState';

export function TeamManagementRoute() {
  const teamSearchTerm = useAppSelector((state) => state.team.teamSearchTerm);
  const includeDeleted = useAppSelector(
    (state) => state.team.showDeletedMemberships
  );

  // TODO: There does not appear to be a way to check for literal membership in string union at runtime
  const orderBy = useSearchParams()[0].get(
    'ordering'
  ) as MembersListApiArg['ordering'];
  const { pagination, handlePaginationChange, paramsWithPage } =
    usePaginationState<MembersListApiArg>({
      search: teamSearchTerm,
      ordering: orderBy,
      deletedObjects: includeDeleted ? 'include' : undefined,
    });
  const {
    data: members,
    isLoading,
    isFetching,
  } = useMembersListQuery(paramsWithPage);

  return (
    <>
      {isLoading || isFetching ? (
        <div className="my-72 flex justify-center">
          <LoadingIndicator />
        </div>
      ) : (
        <>
          <div>
            <DataGrid
              tableId="team-management"
              columns={includeDeleted ? columnsWithDeletedAt : columns}
              data={members?.results || []}
              pagination={pagination}
              totalCount={members?.count || 0}
              handlePaginationChange={handlePaginationChange}
              emptyState={<MemberEmptyState />}
              orderedBy={orderBy as string}
              getRowId={(row) => row.id}
            />
          </div>
        </>
      )}
      <MemberForm />
    </>
  );
}
